import api from './api';

class LocationsService {
    /**
     * Get locations for the authenticated vendor
     * @param {Object} params - Query parameters (is_active, etc.)
     * @returns {Promise} API response
     */
    async getLocations(params = {}) {
        try {
            const response = await api.get('/vendors/locations', { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get location details by ID
     * @param {number} locationId - Location ID
     * @returns {Promise} API response
     */
    async getLocationDetail(locationId) {
        try {
            const response = await api.get(`/vendors/locations/${locationId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get drivers for a specific location
     * @param {number} locationId - Location ID
     * @param {Object} params - Query parameters
     * @returns {Promise} API response
     */
    async getLocationDrivers(locationId, params = {}) {
        try {
            const response = await api.get(`/vendors/locations/${locationId}/drivers`, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Update location status (active/inactive)
     * @param {number} locationId - Location ID
     * @param {boolean} isActive - Active status
     * @returns {Promise} API response
     */
    async updateLocationStatus(locationId, isActive) {
        try {
            const response = await api.put(`/vendors/locations/${locationId}/status`, {
                is_active: isActive
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get location statistics
     * @param {number} locationId - Location ID
     * @returns {Promise} API response
     */
    async getLocationStats(locationId) {
        try {
            const response = await api.get(`/vendors/locations/${locationId}/stats`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const locationsService = new LocationsService();
